<script></script>

<section id="buy_a_penguin">
  <div>
    <h2>PENGUINS ARE ON THE <br /> LOOSE COLLECT THEM ALL!</h2>
    <p>
      All of these penguins are on the loose. Some of them have swag, some of
      them are cute, and some of them can even fly.
    </p>
    <br />
    <p>
      Maybe, just maybe if you’re lucky, you can encounter a shiny penguin with
      the “coolest” fur on the pole. Be quick and be icy, like a penguin!
    </p>
    <div class="cta-container">
      <a href="https://rarible.com/icy-penguin" target="_blank" class="cta">BUY A PENGUIN ON RARIBLE</a>
    </div>
  </div>
  <div>
    <img src="images/13.png" alt="icy penguin 13" class="penguin" />
    <img src="images/19.png" alt="icy penguin 19" class="penguin" />
    <img src="images/107.png" alt="icy penguin 107" class="penguin" />
    <img src="images/238.png" alt="icy penguin 238" class="penguin" />
  </div>
</section>

<style>
  section {
    display: flex;
  }

  h2 {
    font-size: 1.5rem;
    font-style: italic;
    margin-bottom: 1em;
  }

  div:nth-child(1) {
    flex: 1;
    text-align: left;
    padding: 2em 0;
    padding-right: 2em;
  }

  .cta {
    all: unset;
    cursor: pointer;
    background: #573667;
    text-align: center;
    font-weight: 900;
    padding: 1.5rem 2.3rem;
    border-radius: 0.5rem;
    border: 3px solid #573667;
    margin-top: 1.5em;

    transition: .2s ease;
  }

  .cta:hover {
    background: transparent;
    border: 3px solid #573667;
  }

  .cta-container {
    transition: 0.3s ease;
    margin-top: 3rem;
  }

  div:nth-child(2) {
    flex: 1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 20px;
    row-gap: 20px;
    justify-items: center;
    padding: 2em 0;
  }

  div > img {
    width: 100%;
    border-radius: 0.5rem;
    image-rendering: pixelated;
  }

  @media (max-width: 768px) {
    section {
      flex-direction: column;
    }
    div:nth-child(1) {
      padding-right: 0;
    }
  }
</style>
